import { render, staticRenderFns } from "./NestedSuiteTestCase.vue?vue&type=template&id=bec097a6&scoped=true&"
import script from "./NestedSuiteTestCase.vue?vue&type=script&lang=js&"
export * from "./NestedSuiteTestCase.vue?vue&type=script&lang=js&"
import style0 from "./NestedSuiteTestCase.vue?vue&type=style&index=0&id=bec097a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec097a6",
  null
  
)

export default component.exports